import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Paczka klienta leżąca na serwerze (/opt/koselig2/downloads). null = jeszcze sprawdzamy.
export function usePackage() {
  const [pkg, setPkg] = useState(null);
  useEffect(() => {
    api.get("/client/package").then((r) => setPkg(r.data)).catch(() => setPkg({ available: false }));
  }, []);
  return pkg;
}
